// src/app/views/pages_admin/menu_ctrl/rtAdMenuCtrl.js
import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { EXAM_TYPES } from "app/types/examTypes";

const MenuCtrl = Loadable(lazy(() => import("./MenuCtrl")));

const rtAdMenuCtrl = Object.values(EXAM_TYPES).map(examType => ({
  path: `${examType.pathPrefix}/menu-ctrl/:rid_cd_ext`,
  element: <MenuCtrl key={`menu-ctrl-${examType.rid_cd_ext}`} />
}));

export default rtAdMenuCtrl;
